export enum PersonAttributes {
  Title = 'Title',
  FirstName = 'FirstName',
  MiddleName = 'MiddleName',
  LastName = 'LastName',
  PreferredName = 'PreferredName',
  Gender = 'Gender',
  DateOfBirth = 'DateOfBirth',
  RelationshipStatus = 'RelationshipStatus',
}

export enum AdditionalAttributes {
  BankingInstitution = 'BankingInstitution',
  RepayingStudentLoan = 'RepayingStudentLoan',
  PermanentResident = 'PermanentResident',
  AustralianCitizen = 'AustralianCitizen',
}

export enum AssetType {
  Property = 'Property',
  Vehicle = 'Vehicle',
  Other = 'Other',
  Superannuation = 'Superannuation',
  PropertySecurityGuarantee = 'Property (Security Guarantee)',
}

export enum LoanPurpose {
  Purchase = 'Purchase',
  Refinance = 'Refinance',
  RenovationConstruction = 'Renovation / Construction',
  SwitchRefix = 'Switch / Refix',
  TitleBuyout = 'Title Buyout',
  TopUp = 'Top Up',
  Reverse = 'Reverse',
  OtherPersonal = 'Other / Personal',
  Business = 'Business',
  Consumer = 'Consumer',
  Commercial = 'Commercial',
  UnsecuredPersonal = 'Unsecured Personal',
  Insurance = 'Insurance',
  Refix = 'Refix',
}

export enum OpportunityAttributes {
  Name = 'Name',
  EstimatedAmount = 'EstimatedAmount',
  CreditAdviceFee = 'CreditAdviceFee',
  HowDidTheyHearAboutUs = 'HowDidTheyHearAboutUs',
  CreatedDate = 'CreatedDate',
  WorkflowStatus = 'WorkflowStatus',
  ProviderReference = 'ProviderReference',
  ReferrerArrangement = 'ReferrerArrangement',
  AssignedTo = 'AssignedTo',
  KYC = 'KYC',
  FactFind = 'FactFind',
  ModeSelector = 'ModeSelector',
  AdviserCampaignId = 'AdviserCampaignId',
  Tags = 'Tags',
}

export enum PropertyPurchaseAttributes {
  PurchaseAmount = 'PurchaseAmount',
  LoanAmount = 'LoanAmount',
  PropertyType = 'PropertyType',
  Zoning = 'Zoning',
  LandSize = 'LandSize',
  TitleType = 'TitleType',
  PurchaseStatus = 'PurchaseStatus',
  Address = 'Address',
  UseAfterSettlement = 'UseAfterSettlement',
  SettlementDate = 'SettlementDate',
  FinanceDate = 'FinanceDate',
  UseAsSecurity = 'UseAsSecurity',
  NewBuilding = 'NewBuilding',
  OTPDutiableLandValue = 'OTPDutiableLandValue',
}

export enum PropertyPurchaseFinancials {
  ConveyancerCosts = 'ConveyancerCosts',
  GenuineSavings = 'GenuineSavings',
  DepositPaid = 'DepositPaid',
  Gift = 'Gift',
  OngoingWeeklyRent = 'OngoingWeeklyRent',
  OtherCosts = 'OtherCosts',
  FirstHomeBuyer = 'FirstHomeBuyer',
  FirstHomeBuyerGrant = 'FirstHomeBuyerGrant',
  RequiresBridgingFinance = 'RequiresBridgingFinance',
  StampDutyUpfront = 'StampDutyUpfront',
  LMIWaived = 'LMIWaived',
}

export enum MenuAttributes {
  MenuHeader = 'Header',
  Summary = 'Summary',
  CustomerNeeds = 'Customer Needs',
  FactFind = 'Fact Find',
  Applicants = 'Applicants',
  Income = 'Income',
  Assets = 'Assets',
  Liabilities = 'Liabilities',
  Purpose = 'Purpose',
  BorrowingCapacity = 'Borrowing Capacity',
  FundsPosition = 'Funds Position',
  ProductSelection = 'Product Selection',
  MyProtectionPlan = 'My Protection Plan',
  Documents = 'Documents',
  LoanTracker = 'Loan Tracker',
  Notes = 'Notes',
  Tasks = 'Tasks',
  Refixes = 'Refixes',
  Events = 'Events',
  Audit = 'Audit',
}

export enum TextAttributes {
  OpportunityNameLabel = 'OpportunityNameLabel',
  CopyDetailsLabel = 'CopyDetailsLabel',
  SearchOpportunitiesPlaceholder = 'SearchOpportunitiesPlaceholder',
  OpportunityHeader = 'OpportunityHeader',
  EditOpportunity = 'EditOpportunity',
  OpportunityNameValidation = 'OpportunityNameValidation',
  OpportunitySelectionRequired = 'OpportunitySelectionRequired',
  SubmissionModalHeaderSubmitting = 'SubmissionModalHeader',
  SubmissionModalHeaderSubmitted = 'SubmissionModalHeaderSubmitted',
  SubmissionInProgress = 'SubmissionInProgress',
  SubmissionComplete = 'SubmissionComplete',
  SubmissionModalButton = 'SubmissionModalButton',
  SubmissionStatusTimeOut = 'SubmissionStatusTimeOut',
  SubmissionProductRecommendationRequired = 'SubmissionProductRecommendationRequired',
  ProductSearchPlaceholder = 'ProductSearchPlaceholder',
  SubmitOpportunityTitle = 'SubmitOpportunityTitle'
}

export enum ProductSearchResultAttributes {
  ProductName = 'ProductName',
  Rate = 'Rate',
  RateType = 'RateType',
  Term = 'Term',
  MaxLVR = 'MaxLVR',
  SLA = 'SLA',
  LoyaltyNPS = 'LoyaltyNPS',
  MaxLoanAmount = 'MaxLoanAmount',
}

export enum ProductType {
  SingleOnly = 'SingleOnly',
  PackageOnly = 'PackageOnly',
  Both = 'Both',
}

export enum ProductFeature {
  BasicHomeLoan = 'Basic Home Loan',
  ProPackDiscount = 'Pro-Pack / Discount',
  InvestmentLending = 'Investment Lending',
  LineOfCredit = 'Line Of Credit',
  Construction = 'Construction',
  SplitAccount = 'Split Account',
  FamilyGuarantee = 'Family Guarantee',
  NonGenuineSavings = 'Non-Genuine Savings',
  Redraw = 'Redraw',
  Offset = 'Offset',
  ExtraPayments = 'Extra Payments',
  SecuritySubstitution = 'Security Substitution',
  InterestCapitalise = 'Interest Capitalise',
  Bridging = 'Bridging',
  ReverseMortgage = 'Reverse Mortgage',
}

export enum ProductDetails {
  Lender = 'Lender',
  Product = 'Product',
  Amount = 'Amount',
  LoanTerm = 'Loan term',
}

export enum ProductFeeType {
  Application = 'Application',
  Valuation = 'Valuation',
  Discharge = 'Discharge',
  MonthlyService = 'Monthly service',
  AnnualService = 'Annual service',
  Brokerage = 'Brokerage',
}

export enum SubmissionAttributes {
  ShowSubmissionModal = 'ShowSubmissionModal',
  EmitSubmissionEvent = 'EmitSubmissionEvent',
}

export enum PaygIncomeAttributes {
  TaxExemptIncome = 'TaxExemptIncome',
}
